import { SessionData } from './initializer';
import { Platform } from './getEnvironmentContext';

// The following juggling keeps State types in sync with SessionData types,
// while increasing what is required to satisfy the State's more stringent requirements:
type StateSessionDataRequired = Pick<
    SessionData,
    'pageType' |
    'appId' |
    'property' |
    'subscriptionStatus' |
    'authState' |
    'endpoint' |
    'endpointOptions' |
    'testCells' |
    'staging' |
    'userAgent' |
    'url' |
    'referrer' |
    'product' |
    'businessUnit'
>

type StateSessionDataOptional = Pick<
    SessionData,
    'clientIpAddress' |
    'appVersion' |
    'cheggUuid'
>;

export type StateInternallyDerived = {
    browserName: string;
    browserVersion: string;
    osName: string;
    osVersion: string;
    platform: Platform;
    afVersion: string;
    adRevenue?: number;
}

// Combine all required and optional data from the init with internally-derived values to produce the full state object:
export type State = Partial<StateSessionDataOptional> & Required<StateSessionDataRequired> & StateInternallyDerived;

export type StateUpdateWhitelistObject = Partial<State>;

export type UpdateStateFn = (stateChunk: StateUpdateWhitelistObject) => void;

export interface StateManager {
    get: () => State;
    update: UpdateStateFn;
    reset: () => void;
};

let state = {} as State;

const stateManager: StateManager = {
    get: () => Object.assign({}, state),
    update: (stateChunk) => {
        state = Object.assign({}, state, stateChunk);
    },
    reset: () => { state = {} as State },
};

export default stateManager;
